
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class BackToTop extends Vue {
  name: 'BackToTop';

  mounted() {
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if(scroll != 0) {
        $(".back-to-top").addClass("show-btn");
      } else {
        $(".back-to-top").removeClass("show-btn");
      }
    });

    $(".back-to-top").click(function () {
      $("html, body").animate({scrollTop: 0}, 1000);
    });
  }
}
